<template>
  <div class="animated fadeIn">

    <div class="loading" v-if="loading">
      <div class="spinner"></div>
    </div>

    <!-- table -->
    <b-card v-show="so.adv" class="mt-2">
      <b-row>
        <b-col md="6">
          <b-form-group>
            <label>Registed_at</label>
            <b-form inline>
              <date-picker class="mt-2 mr-2" v-model="so.opt.created_at_sd" style="width: 140px" :confirm="false"
                :first-day-of-week="1" @keyup.enter="refresh"></date-picker>
              ~
              <date-picker class="ml-2" v-model="so.opt.created_at_ed" style="width: 140px" :confirm="false"
                :first-day-of-week="1" @keyup.enter="refresh"></date-picker>
            </b-form>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group>
            <label>File Size</label>
            <b-form inline>
              <b-input type="number" v-model="so.opt.from_size"></b-input>
              <strong class="font-weight-bold ml-2 mr-2">
                ~
              </strong>
              <b-input type="number" v-model="so.opt.to_size"></b-input>
            </b-form>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <b-form-group class="text-primary" label="Only Obfuscated">
            <c-switch color="info" label size="lg" v-model="so.opt.filter_ob" />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group class="text-primary" label="Only Pattern">
            <c-switch color="info" label size="lg" v-model="so.opt.filter_pattern" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <b-form-group class="text-primary" label="Obfuscated Category">
            <v-select label="name" v-model="so.opt.filter_ob_type" :options="ob_list"></v-select>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group class="text-primary" label="Excension Category">
            <v-select label="name" v-model="so.opt.filter_extension_category" :options="extenstion_category"></v-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-form-group class="float-right">
        <b-button class="mr-1" size="sm" variant="danger" @click="so.adv = false"> Close </b-button>
        <b-button class="mr-1" size="sm" variant="light" @click="resetField"> Reset </b-button>
        <b-button size="sm" variant="primary" @click="refresh"> Search </b-button>
      </b-form-group>
    </b-card>

    <b-row class="text-center">
      <b-col>
        <b-form-group label="Select for showing Column" >
          <b-form-checkbox-group
            :options="fields_custom"
            v-model="select"
            buttons
            button-variant="primary"
            size="sm"
            name="label"
          ></b-form-checkbox-group>
        </b-form-group>
      </b-col>
    </b-row>
    <hr>
    <b-row class="mt-1">
      <b-col md="4">
        <b-form-fieldset style="width : 120px" size="sm">
          <b-form-select :options="so.pageoptions" v-model="so.perPage">
          </b-form-select>
        </b-form-fieldset>
      </b-col>
      <b-col md="4">
      </b-col>
      <b-col>
        <b-input-group style="" size="sm" class="float-right">
          <b-input-group-prepend>
            <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-refresh"></i></b-btn>
            <b-btn variant="outline-secondary" @click="reset()"><i class="fa fa-remove"></i></b-btn>
            <b-dropdown :text="so.skt || 'Search'" size="sm" variant="outline-secondary" :disabled="so.adv">
              <b-dropdown-item size="sm" @click="so.sk = 'origin'; so.skt = 'From'">From</b-dropdown-item>
              <b-dropdown-item size="sm" @click="so.sk = 'file_hash'; so.skt = 'Hash(MD5)'">Hash(MD5)</b-dropdown-item>
              <b-dropdown-item size="sm" @click="so.sk = 'extension'; so.skt = 'Extension'">Extension</b-dropdown-item>
              <b-dropdown-item size="sm" @click="so.sk = 'extension_category'; so.skt = 'Extension Category'">Extension Category</b-dropdown-item>
            </b-dropdown>
          </b-input-group-prepend>
          <b-input :disabled="so.adv" v-model="so.sv" @keyup.enter="refresh()"></b-input>
          <b-input-group-append>
            <b-btn :disabled="so.adv" variant="outline-secondary" @click="refresh()"><i class="fa fa-search"></i></b-btn>
            <b-btn variant="outline-secondary" @click="so.adv = !so.adv"><i class="fa"
                :class="{ 'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"></i></b-btn>
          </b-input-group-append>
        </b-input-group>
      </b-col>
    </b-row>

    <b-row class="mt-3 mb-3">
      <b-col>
        <b-button type="button" class="btn btn-cancel btn-block" variant="outline-danger" @click="allow">
          Sync to Pattern
        </b-button>
      </b-col>
      <b-col>
        <b-button type="button" class="btn btn-cancel btn-block" variant="outline-primary" @click="deny">
          Deny to Pattern
        </b-button>
      </b-col>
    </b-row>

    <hr>

    <b-table hover striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="not found"
      style="overflow: auto;"
      :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk" class="">

      <template #cell(id)="row">{{ row.item.id }}</template>

      <template #cell(is_system)="row">
        <b-badge variant="danger" v-if="row.item.is_system">Crawler</b-badge>
        <b-badge v-else variant="warning">User</b-badge>
      </template>

      <template #cell(is_unknown)="row">

        <b-badge variant="dark" v-if="row.item.is_unknown">Obfuscated + {{ tags(row.item.ob_list).length }}</b-badge>
        <span v-else>-</span>
      </template>


      <template #cell(file_size)="row">
        {{ row.item.file_size |  bytes }}
      </template>

      <template #cell(file_hash)="row">
        <a href="javascript:void();" @click="detail(row.item)">{{ (row.item.file_hash || '*******') | truncate(50) }}</a>
      </template>

      <template #cell(ai_general_score)="row">
        <span v-if="row.item.ai_general_result === undefined">
          -
        </span>
        <span v-else class="font-weight-bold" :class="{ 'text-danger' : (row.item.ai_general_score > 0.7) }">
          {{ row.item.ai_general_result }}
          ( {{ (row.item.ai_general_score * 100).toFixed(2) }} % )
        </span>
      </template>

      <template #cell(ai_specify_score)="row">
        <span v-if="row.item.ai_specify_result === undefined">
          -
        </span>
        <span v-else class="font-weight-bold" :class="{ 'text-danger' : (row.item.ai_specify_score > 0.7) }">
          {{ row.item.ai_specify_result }}
          ( {{ (row.item.ai_specify_score * 100).toFixed(2) }} % )
        </span>

      </template>

      <template #cell(extension)="row">
        {{ row.item.extension || '-' }}
      </template>
      <!-- <template #cell(extension_category)="row">{{ row.item.extension_category || '-' }}</template> -->
      <template #cell(created_at)="row">{{ row.item.created_at | datetime2 }}</template>

      <template #cell(origin)="row">
        {{ row.item.origin || '-' }}
      </template>

      <template #cell(country)="row">
        <span v-if="row.item.country">
          {{ row.item.country }}
        </span>
        <span v-if="row.item.country" class="flag-icon" :class="`flag-icon-${row.item.country.toLowerCase()}`">

        </span>
        <span v-else>
          -
        </span>
      </template>

      <template #cell(file_signiture)="row">
        {{ row.item.file_signiture || '-' }}
      </template>


      <template #cell(extension_category)="row">
        {{ row.item.extension_category || '-' }}
      </template>


      <template #cell(is_clear)="row">
        <b-badge variant="warning" v-if="!row.item.is_clear">Done</b-badge>
        <span v-else>-</span>
      </template>


      <template #cell(is_binary)="row">
        <b-badge variant="primary" v-if="row.item.is_binary">Binary</b-badge>
        <span v-else>-</span>
      </template>


      <template #cell(is_excute)="row">
        <b-badge variant="outline-warning" v-if="row.item.is_excute">Excuteable</b-badge>
        <span v-else>-</span>
      </template>

      <template #cell(is_webshell)="row">
        <b-badge variant="outline-dagner" v-if="row.item.is_webshell">Webshell</b-badge>
        <span v-else>-</span>
      </template>

      <template #cell(is_pattern)="row">
        <b-badge variant="outline-dagner" v-if="row.item.is_pattern">Pattern</b-badge>
        <span v-else>-</span>
      </template>

      <template #cell(is_approve)="row">
        <b-badge variant="dark" v-if="row.item.is_approve">approval</b-badge>
        <span v-else>-</span>
      </template>

      <template #cell(is_ob)="row">
        <b-badge variant="dark" v-if="row.item.is_ob">Obfuscated</b-badge>
        <span v-else>-</span>
      </template>
    </b-table>

    <hr>

    <b-row>
      <b-col>
      </b-col>
      <b-col class="mt-1 d-flex justify-content-center">
        <b-pagination size="sm" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage"
          prev-text="Prev" next-text="Next" />
      </b-col>
      <b-col>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import vSelect from 'vue-select';
import _ from 'lodash';
import DatePicker from 'vue2-datepicker'
import datepicker from '@/f1/custom';
import { api } from '@/f1/service';
import 'vue2-datepicker/index.css';
import moment from 'moment-timezone';
import { Switch as cSwitch } from '@coreui/vue';

const default_opt = () => ({
  perPage: 25,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt: {
    created_at_ed: moment().add(1, 'd').format('YYYY-MM-DD'),
    created_at_sd: moment().add(1, 'd').format('YYYY-MM-DD'),
  }, adv: false,
  pageoptions: [
    { text: '1 rows', value: 1 },
    { text: '10 rows', value: 10 },
    { text: '25 rows', value: 25 },
    { text: '50 rows', value: 50 },
    { text: '100 rows', value: 100 },
    { text: '200 rows', value: 200 },
    { text: '500 rows', value: 200 }
  ]
});

export default {
  name: 'wait',
  components: { DatePicker, vSelect, cSwitch },
  data: () => ({
    loading : false,
    ob_list: [],
    extenstion_category: [
      "asp", "jsp", "perl", "php", "python", "ruby", "javascript", "java", "etc", "unknown"
    ],
    family: [
      { text: '-', value: '' },
    ],
    model: {
      family: ''
    },
    datepicker,
    so: default_opt(),
    hash_list: [],
    select : [],
    fields_default : [
      { _show: true, key: 'id', thStyle: 'width: 6%', sortable: true, label: 'No' },
      // { _show: true, key: 'is_system', sortable: true, label: 'From' },
      { _show: true, key: 'is_unknown', sortable: true, label: 'Suspicious' },
      { _show: true, key: 'file_size', thStyle: 'width: 6%', sortable: true, label: 'Size' },
      { _show: true, key: 'file_hash', sortable: true, label: 'Hash(md5)' },
      { _show: true, key: 'ai_general_score', sortable: true, label: 'Ai General Score' },
      { _show: true, key: 'ai_specify_score', sortable: true, label: 'Ai Specify Score' },
      { _show: true, key: 'extension', sortable: true, label: 'Extenstion' },
      { _show: true, key: 'created_at', sortable: true, label: 'Registed_at' },
    ],

    fields_custom : [
      { _show: false, key: 'origin', sortable: true, text: 'Origin', },
      { _show: false, key: 'country', sortable: true, text: 'Country', },
      { _show: false, key: 'file_signiture', sortable: true, text: 'File Signiture', },
      { _show: false, key: 'extension_category', sortable: true, text: 'Ext Category', },
      // { _show: false, key: 'is_alive', sortable : false, text: 'is_alive', },
      { _show: false, key: 'is_system', sortable : false, text: 'From', },
      { _show: false, key: 'is_clear', sortable : false, text: 'Status', },
      { _show: false, key: 'is_binary', sortable : false, text: 'Binary', },
      { _show: false, key: 'is_excute', sortable : false, text: 'Excuteable', },
      { _show: false, key: 'is_webshell', sortable : false, text: 'Webshell', },
      { _show: false, key: 'is_pattern', sortable : false, text: 'With Pattern', },
      { _show: false, key: 'is_approve', sortable : false, text: 'Approve', },
      { _show: false, key: 'is_ob', sortable : false, text: 'Obfuscated', },

    ]
  }),
  computed: {
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() {
      let rv = this.fields_default

      return rv.concat(_.filter(this.fields_custom, x => {
        x.label = x.text

        // console.log('this.select', this.select, x.key)
        if(this.select.indexOf(x.text) > -1) { return true }

        return x._show == true
      }))
    }
  },
  methods: {
    async allow() {
      try {
        this.loading = true
        let rs = await api.dms.webshell.allow(this.hash_list);
        console.log("rs", rs)
        this.refresh()

      } catch (e) { this.$toastr.e(e.data || e); }
      finally { this.loading = false; }
    },

    async deny() {
      try {
        this.loading = true
        let rs = await api.dms.webshell.deny(this.hash_list);
        console.log("rs", rs)
        this.refresh()

      } catch (e) { this.$toastr.e(e.data || e); }
      finally { this.loading = false; }
    },

    tags(ob_list='[]') {
      try {
        return JSON.parse(ob_list)
      } catch (e) {
        console.log(e, ob_list)
        return []
      }
    },
    resetField() { this.so = default_opt(); this.refresh(); this.so.adv = !this.so.adv },
    reset() { this.so = default_opt(); this.refresh(); },
    refresh() {
      this.$refs._list.refresh();
    },
    getRowCount() { return this.so.totalRows || 0; },
    getItems(ctx) { return this.load(ctx); },
    async load(ctx = {}) {
      this.loading = true;
      let so = {
        ok: ctx.sortBy,
        od: ctx.sortDesc ? 'd' : 'a',
        pg: ctx.currentPage || this.so.currentPage || 1,
        pc: ctx.perPage || this.so.perPage || 10,
        sk: this.so.sk || 'file_hash',
        sv: (this.so.sv || '').trim(),
        opt: this.so.adv ? Object.assign({}, this.so.opt) : {}
      }
      // Build all
      var search = { limit: so.pc, offset: (so.pg - 1) * so.pc, and: [], or: [], sort: [] }

      search.and.push({ name: 'is_del', op: '=', value: false })
      search.and.push({ name: 'is_alive', op: '=', value: true })
      search.and.push({ name: 'is_clear', op: '=', value: false })

      // order
      if (so.ok) { search.sort.push({ name: so.ok, op: so.od == 'd' && 'desc' }); }
      // search

      if (so.sk && so.sv) {
        if (!so.ok) {
          search.sort.push({ name: so.sk, op: so.od == 'd' && 'desc' });
        }
        search.or.push({ name: so.sk, value: `%${so.sv.trim()}%`, op: 'like' });
      }
      // search (adv)
      for (let [key, value] of Object.entries(so.opt)) {
        console.log('key', key, 'value', value)
        if (value != null && value != "") {
          switch (key) {
            case 'created_at_sd': search.and.push({ name: 'created_at', value: new Date(value), op: '>=' }); break;
            case 'created_at_ed': var d = new Date(value); d.setDate(d.getDate() + 1); search.and.push({ name: 'created_at', value: d, op: '<' }); break;

            case 'from_size': value > 0 ? search.and.push({ name: 'file_size', value: Number(value), op: '>' }) : ''; break;
            case 'to_size': value > 0 ? search.and.push({ name: 'file_size', value: Number(value), op: '<' }) : ''; break;

            case 'filter_ob': search.and.push({ name: 'is_ob', value: value, op: '=' }); break;
            case 'filter_pattern': search.and.push({ name: 'is_pattern', value: value, op: '=' }); break;

            case 'filter_ob_type': search.and.push({ name: 'ob_list', value: `%${value}%`, op: 'like' }); break;
            case 'filter_extension_category': search.and.push({ name: 'extension_category', value: value, op: '=' }); break;

            default: search.and.push({ name: key, value: `%${value}%`, op: 'like' }); break;
          }
        }
      }

      try {

        let rs = await api.dms.webshell.list(search);
        this.so.totalRows = rs.count;

        this.hash_list = _.map(rs.result, x => x.file_hash)

        this.get_ob_filter()

        return rs.result;

      } catch (e) { this.$toastr.e(e.data || e); }
      finally {
        this.loading = false;
      }
    },
    async get_ob_filter(ctx = {}) {
      let so = {
        ok: ctx.sortBy,
        od: ctx.sortDesc ? 'd' : 'a',
        pg: 1,
        pc: 100,
        sk: this.so.sk || '',
        sv: (this.so.sv || '').trim(),
        opt: this.so.adv ? Object.assign({}, this.so.opt) : {}
      }
      // Build all
      var search = { limit: so.pc, offset: (so.pg - 1) * so.pc, and: [], or: [], sort: [] }

      search.and.push({ name: 'is_alive', op: '=', value: true })

      try {
        let rs = await api.dms.regex.list(search);

        this.ob_list = _.map(rs.result, x => x.name)

      } catch (e) { this.$toastr.e(e.data || e); }
    },
    detail(item) { this.$router.push({ name: 'uwss_webshell', params: { id: item.id } }); },
  },
  created() { },
  destroyed() { },
  mounted() {  },
}
</script>
